module.exports = __webpack_public_path__ + "assets/img/16_1818_big.9a789210.jpg";